import { Component, OnInit, Inject } from '@angular/core';
import { ComponentOnSystemInspectionViewModel, SwapRollerEndPoint } from '../../models/create-inspection.model';
import { LoadingService } from '../../../../shared/services/loading.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-swap-roller-model',
  templateUrl: './swap-roller-model.component.html',
  styleUrls: ['./swap-roller-model.component.scss']
})
export class SwapRollerModelComponent implements OnInit {
  ComingFrom: SwapRollerEndPoint;


  allRollers: ComponentOnSystemInspectionViewModel[];
  selectedComponent: ComponentOnSystemInspectionViewModel;
  isloading = false;

  allComponents: ComponentOnSystemInspectionViewModel[];

  swapRollerEvent(swapWithComponent: ComponentOnSystemInspectionViewModel) {
    const newPositionToBe = swapWithComponent.ActualPosition;
    const oldPositionBackTo = this.selectedComponent.ActualPosition;
    const newPositionLabelToBe = swapWithComponent.Position;
    const oldPositionLabelBackTo = this.selectedComponent.Position;

    if (this.selectedComponent.OriginalPosition === undefined) {
      this.selectedComponent.OriginalPosition = oldPositionBackTo;
      this.selectedComponent.Name = this.selectedComponent.Name + '(' + oldPositionBackTo + ')';
    }
    if (swapWithComponent.OriginalPosition === undefined) {
      swapWithComponent.OriginalPosition = newPositionToBe;
      swapWithComponent.Name = swapWithComponent.Name + '(' + newPositionToBe + ')';
    }


    if (+this.ComingFrom === +SwapRollerEndPoint.CreateNewInspection) {
      this.selectedComponent.ActualPosition = newPositionToBe;
      swapWithComponent.ActualPosition = oldPositionBackTo;
      this.selectedComponent.Position = newPositionLabelToBe;
      swapWithComponent.Position = oldPositionLabelBackTo;


      this.dialogRef.close(true);
    } else if (+this.ComingFrom === +SwapRollerEndPoint.Interpretation) {

    } else if (+this.ComingFrom === +SwapRollerEndPoint.RecordNewAction) {
      this.dialogRef.close(swapWithComponent.GeneralEqUnitId);
    }
  }

  constructor(
    public dialogRef: MatDialogRef<SwapRollerModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _loading: LoadingService,
    ) { }

  ngOnInit() {
    if (this.data.selectedComponent !== undefined && this.data.allRollers !== undefined)    {
      this.selectedComponent = this.data.selectedComponent;
      this.allRollers = this.data.allRollers;
      this.ComingFrom = this.data.comingFrom;
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
